import * as React from 'react';
import { connect } from 'react-redux';
import { handleError } from '../../shared/ErrorCatching';
import LogsList from '../../components/logs/LogsList';
import Pagination from '../../components/common/Pagination';
import * as Actions from './Actions';
import ListSkeleton from '../orders/list/brokerAgentOrderList/v2/components/ListSkeleton';
import LogsSkeleton from './LogsSkeleton';

interface IProps {
    id: number;
    type: string;
    logs: { items: any[]; numberOfPages: number };
    actions: IActions;
    pageSize?: number;
    userHeader?: string;
}

interface IActions {
    get(id: number, type: string, page?: number, pageSize?: number): Promise<any>;
}

interface IState {
    isLoading: boolean;
    page: number;
    pageSize: number;
}

export class LogListWithPager extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            isLoading: false,
            page: 1,
            pageSize: this.props.pageSize ? this.props.pageSize : 25
        };
        this.onPageChanged = this.onPageChanged.bind(this);
    }

    componentDidMount(): void {
        this.setState({isLoading: true});
        this.props.actions
            .get(this.props.id, this.props.type, this.state.page, this.state.pageSize)
            .then(() => this.setState({isLoading: false}))
            .catch((error: any) => {
                handleError(error);
                this.setState({isLoading: false});
            });
    }

    onPageChanged(page: any) {
        this.setState({ page: page } as IState, () =>
            this.props.actions.get(
                this.props.id,
                this.props.type,
                this.state.page,
                this.state.pageSize
            )
        );
    }

    render(): any {
        if (this.state.isLoading) {
            return <LogsSkeleton />
        }

        return (
            <div>
                <LogsList 
                    logs={this.props.logs.items} 
                    userHeader={this.props.userHeader}
                />
                <Pagination
                    maxNumberOfButtons={5}
                    activePage={this.state.page}
                    onPageSelect={this.onPageChanged}
                    numberOfPages={this.props.logs.numberOfPages}
                />
            </div>
        );
    }
}

function mapStateToProps(state: any) {
    return {
        logs: state.logs2
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            get: (id: number, type: string, page?: number, pageSize?: number) =>
                dispatch(Actions.list(id, type, page, pageSize))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(LogListWithPager);
